import React from 'react';
import { Nav } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import shortid from 'shortid';

type Props = {
  readonly enable?: boolean;
  readonly text: string;
  readonly to: string | object;
  readonly exact?: boolean;
  readonly strict?: boolean;
  readonly contextMenu?: React.MouseEventHandler<HTMLAnchorElement>;
};

const NavLinkItem = ({
  enable = true,
  text,
  to,
  exact = false,
  strict = false,
  contextMenu,
}: Props) => (
  <>
    {enable && (
      <Nav.Link
        as={NavLink}
        exact={exact}
        strict={strict}
        className="ps-3"
        to={to}
        eventKey={shortid()}
        onContextMenu={contextMenu}
      >
        {text}
      </Nav.Link>
    )}
  </>
);

export default NavLinkItem;

